export const specialCharacterRegex = /[<>:"/\\|?*]/
